<template>
  <el-scrollbar height="100%" @end-reached="onScroll" distance="100">

    <div class="masonry">
      <div v-for="item in resourceList" :key="item.id" class="masonry-item cursor-pointer">
        <div class="masonry-content" @click="handleClick(item)">
          <img :src="item.full_preview_url" alt="" class="media" />
        </div>
      </div>
    </div>
    <div v-if="resourceList.length === 0">
      <el-empty description="暂无数据" />
    </div>
  </el-scrollbar>
</template>
<script lang="ts" setup>
import { ElInput, ElButton, ElIcon, ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox, ElMessage, ElEmpty, ElInfiniteScroll, ElScrollbar } from 'element-plus'
import { Folder, Search, Filter, FolderRemove, FolderOpened, Plus, ArrowLeft } from '@element-plus/icons-vue'
import { ref, computed, onMounted, nextTick, onBeforeUnmount, watch } from 'vue'
import { getResourceList } from '@/api/affairs'
import { useSdkStore } from '@/stores/sdk'

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
onMounted(() => {
  getList()

})

const props = defineProps({
  id: {
    type: Number,
    default: 0
  },
  corp_code: {
    type: String,
    default: ''
  }
})
watch(() => props.id, (newVal, oldVal) => {
  if (newVal != oldVal) {
    pageNum.value = 1
    hasMore.value = true
    getList(false)
  }
})

const resourceList = ref([])
const scrollRef = ref<HTMLElement | null>(null)
const pageNum = ref(1)
const pageSize = ref(50)
const hasMore = ref(true)
const loadingMore = ref(false)
const totalPage = ref(0)
const getList = (append = false) => {
  if (append && loadingMore.value) return
  if (append) loadingMore.value = true
  getResourceList({
    page: pageNum.value, size: pageSize.value, file_type: 2, folder_id: props.id, corp_code: props.corp_code, owner_type: 'team'
  }).then(res => {
    const items = res?.data?.data?.items || []
    totalPage.value = res?.data?.data?.total_pages || 0

    if (append) {
      resourceList.value = (resourceList.value || []).concat(items)
    } else {
      resourceList.value = items
    }
    hasMore.value = items.length === pageSize.value
  }).finally(() => {
    loadingMore.value = false
  })
}

defineExpose({ getList })




const handleClick = (item: any) => {
  desginsdk.addElement.createImageElement(item.full_preview_url)
}
const onScroll = (e: string) => {
  console.log('totalPage', totalPage.value)
  if (pageNum.value >= totalPage.value) return
  if (e == 'bottom') {
    pageNum.value += 1
    getList(true)
  }
  // console.log('nearBottom', e)
  // const el = (e.target as HTMLElement) || scrollRef.value
  // if (!el || !hasMore.value || loadingMore.value) return
  // const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 16

  // if (nearBottom) {

  //   pageNum.value += 1
  //   getList(true)
  // }
}
</script>

<style lang="scss" scoped>
.masonry {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.masonry-item {}

.masonry-content {
  border-radius: 10px;
  overflow: hidden;
  background: #f5f7fa;
  aspect-ratio: 1 / 1;
}

.media {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
</style>
